import isArrayNotEmpty from 'utils/isArrayNotEmpty';

/**
 * Normalizing dispansary locations by cities.
 *
 * From: [{location: 'Location One', city: 'Berlin'}, {location: 'Dispensary Tow', city: 'Bundas '}]
 * To: {berlin: [{ city: 'Berlin', location: 'Dispensary One }, ...], bundas: [...]}
 *
 *  TODO: Create service to transform locations data.
 *
 * @param {Array} locations List of avaliable locations/dispensaries
 * @returns {Object}
 */
export default function getNormalizedLocationsByCities(locations = []) {
  if (!isArrayNotEmpty(locations)) return {};

  const citiesLocations = [...locations]
    .sort((a, b) => a.city?.localeCompare(b.city))
    .reduce((cities, location) => {
      if (location.city) {
        const id = location?.city.toLowerCase().replace(' ', '-');

        if (cities[id]) cities[id].locations.push(location);
        else
          cities[id] = {
            id,
            name: location.city,
            locations: [location],
          };
      }

      return cities;
    }, {});

  return citiesLocations;
}
